const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const OpsSchool = require("./vault/OpsSchool");
const SortableTable = require("./SortableTable");
const Link = require("../core/view/Link");
const URLMake = require("../../shared/URLMake");
const ClassesUtil = require("./util/ClassesUtil");
const StaffTables = require("./StaffTables");
const EditPencil = require("../office/EditPencil");
const CopyTable = require("./data/CopyTable");
const {getDisplayedGradeLabel} = require("../../shared/SchoolUtil");

const styles = require("./styles/AccountList.css");

module.exports = createReactClass({
	displayName: "AccountsList",

	propTypes: {
		user: PT.object.isRequired,
		tab: PT.string,
		pageData: PT.object,
		schoolState: PT.object.isRequired,
		grade: PT.number,
		year: PT.number,
		displayedGrade: PT.number,
		showModal: PT.func,
	},

	getSchoolData: function(schools) {
		const {schoolState, user} = this.props;
		const purchaseActive = OpsSchool.isPurchaseActive(schoolState);
		const activeClasses = _.filter(schoolState.accounts.classes, "active");
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
		return schools.map(s => {
			const linkTo = URLMake.forSchoolAccount(s.id);
			const activeTeachers = OpsSchool.getActiveTeachersForSchool(
				schoolState,
				s.id
			);
			const studentIDs = OpsSchool.getActiveStudentIDsForSchool(
				schoolState,
				s.id
			);
			const isActive = OpsSchool.isSchoolActive(schoolState, s.id);
			const role = OpsSchool.getBestRoleForSchool(
				schoolState,
				user.userID,
				s.id
			);
			const hasPerms = _.includes(["purchaseAdmin", "schoolAdmin"], role);
			const activeSchoolClasses = _.filter(
				activeClasses,
				c => c.schoolID === s.id
			);

			return {
				name: (
					<div className={styles.editable}>
						{isActive && hasPerms && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										schoolID: s.id,
										type: "displayName",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						<Link to={linkTo} className={styles.link}>
							{s.displayName}
						</Link>
					</div>
				),
				nameValue: s.displayName,
				classes: activeSchoolClasses.length,
				teachers: activeTeachers.length,
				students: studentIDs.length,
				inactive: !isActive,
				status: purchaseActive && !s.active ? "Inactive" : "",
			};
		});
	},

	getClassData: function(classes) {
		const {schoolState, pageData, user} = this.props;
		const {schoolID} = pageData;
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);

		return classes.map(c => {
			const linkTo = URLMake.forClassAccount(c.id);
			const school = OpsSchool.getSchoolForClass(schoolState, c.id);
			const schoolLink = URLMake.forSchoolAccount(school.id, "classes");
			const isActive = OpsSchool.isClassActive(schoolState, c.id);
			const role = OpsSchool.getBestRoleForClass(
				schoolState,
				user.userID,
				c.id
			);
			const hasPerms = _.includes(["purchaseAdmin", "schoolAdmin"], role);
			const schoolEl = schoolID ? (
				school.displayName
			) : (
				<Link className={styles.link} to={schoolLink}>
					{school.displayName}
				</Link>
			);
			const teachers = OpsSchool.getTeachersForClass(schoolState, c.id);
			return {
				name: (
					<div className={styles.editable}>
						{isActive && hasPerms && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										classID: c.id,
										type: "displayName",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						<Link to={linkTo} className={styles.link}>
							{c.displayName}
						</Link>
					</div>
				),
				nameValue: c.displayName,
				school: schoolEl,
				schoolValue: school.displayName,
				grade: getDisplayedGradeLabel(c.displayedGrade),
				gradeSort: c.displayedGrade,
				level: c.gradeID,
				teacher: ClassesUtil.getListDisplay(teachers, "lastName"),
				students: c.activeStudentIDs.length,
				inactive: !isActive,
				status: school.active && !c.active ? "Inactive" : "",
			};
		});
	},

	getStudentData: function(students) {
		const {schoolState, user} = this.props;
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);

		return students.map(s => {
			const linkTo = URLMake.forUserAccount(s.id);
			const displayName = ClassesUtil.getStudentName(s);
			const studentClass = OpsSchool.getClassForStudent(schoolState, s.id);
			const isActive = OpsSchool.isStudentActive(schoolState, s.id);
			const role = OpsSchool.getBestRoleForStudent(
				schoolState,
				user.userID,
				s.id
			);
			const hasLoginPerms = _.includes(["purchaseAdmin", "schoolAdmin"], role);
			const hasPerms = _.includes(
				["purchaseAdmin", "schoolAdmin", "teacher"],
				role
			);
			// Only schoolLogin is editable
			const usernameEl = s.schoolLogin ? (
				<div className={styles.editable}>
					{isActive && hasLoginPerms ? (
						<EditPencil
							onClick={() =>
								this.props.showModal("updateInfo", {
									userID: s.id,
									type: "schoolLogin",
								})
							}
							className={styles.pencil}
						/>
					) : (
						<div className={styles.pencil} />
					)}
					{s.schoolLogin}
				</div>
			) : (
				s.username
			);
			return {
				name: (
					<div className={styles.editable}>
						{isActive && hasPerms && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: s.id,
										type: "name",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						<Link to={linkTo} className={styles.link}>
							{displayName}
						</Link>
					</div>
				),
				nameValue: displayName,
				username: usernameEl,
				class: _.get(studentClass, "displayName"),
				grade: getDisplayedGradeLabel(_.get(studentClass, "displayedGrade")),
				gradeSort: _.get(studentClass, "displayedGrade"),
				level: _.get(studentClass, "gradeID"),
				password: (
					<div className={styles.editable}>
						{isActive && hasPerms ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: s.id,
										type: "password",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						{"*******"}
					</div>
				),
				inactive: !isActive,
				status: studentClass.active && !s.active ? "Inactive" : "",
			};
		});
	},

	sortFunctions: {
		name: body => {
			return _.sortBy(body, ["inactive", r => _.toLower(_.trim(r.nameValue))]);
		},
		school: body => {
			return _.sortBy(body, [
				"inactive",
				r => _.toLower(r.schoolValue || r.school),
			]);
		},
		grade: body =>
			_.sortBy(body, [
				"inactive",
				r => (r.gradeSort != null ? r.gradeSort : -1),
			]),
	},

	headerClasses: {
		name: styles.name,
	},

	widthClasses: {
		name: styles.nameWidth,
		username: styles.username,
		grade: styles.grade,
		level: styles.grade,
		class: styles.class,
		password: styles.password,
		teacher: styles.teacher,
		students: styles.students,
		teachers: styles.teachers,
		classes: styles.classes,
		school: styles.school,
		status: styles.status,
	},

	renderTable: function(type, pageData) {
		const {schoolState, user, grade, year, displayedGrade} = this.props;
		const {schoolID} = pageData;
		let columnNames;
		let tableData = [];
		let headerVals;

		// Don't show active students that were in past years of teacher classes if they only have teacher role.
		const isTeacherOnly = OpsSchool.isTeacherOnly(schoolState, user.userID);

		const isSingleSchool = _.get(
			schoolState,
			"accounts.purchase.isSingleSchool"
		);

		if (type === "students") {
			columnNames = [
				"name",
				"username",
				"class",
				"grade",
				"level",
				"password",
				"status",
			];
			headerVals = [
				"Student",
				"Username",
				"Class",
				"Grade",
				"BA Level",
				"Password",
				"",
			];
			if (OpsSchool.isAcademyPurchase(schoolState)) {
				_.pull(columnNames, "password", "username");
				_.pull(headerVals, "Username", "Password");
			}
			let students = OpsSchool.getViewableStudents(
				schoolState,
				user.userID,
				isTeacherOnly
			);
			if (schoolID) {
				const schoolStudents = OpsSchool.getStudentsForSchool(
					schoolState,
					schoolID
				);
				students = _.filter(schoolStudents, s =>
					_.includes(
						students.map(vs => vs.id),
						s.id
					)
				);
			}
			if (grade != null || year != null || displayedGrade != null) {
				students = _.filter(students, s => {
					const studentClasses = OpsSchool.getClassesForStudent(
						schoolState,
						s.id
					);
					let show = true;
					if (
						grade != null &&
						!_.find(studentClasses, sc => sc.gradeID === grade)
					)
						show = false;
					if (year != null && !_.find(studentClasses, sc => sc.year === year))
						show = false;
					if (
						displayedGrade != null &&
						!_.find(studentClasses, sc => sc.displayedGrade === displayedGrade)
					)
						show = false;
					return show;
				});
			}

			tableData = this.getStudentData(students);
		} else if (type === "classes") {
			if (!schoolID && !isSingleSchool) {
				columnNames = [
					"name",
					"school",
					"grade",
					"level",
					"teacher",
					"students",
					"status",
				];
				headerVals = [
					"Class",
					"School",
					"Grade",
					"BA Level",
					"Teacher",
					"Active Students",
					"",
				];
			} else {
				columnNames = [
					"name",
					"grade",
					"level",
					"teacher",
					"students",
					"status",
				];
				headerVals = [
					"Class",
					"Grade",
					"BA Level",
					"Teacher",
					"Active Students",
					"",
				];
			}
			let classes = OpsSchool.getViewableClasses(schoolState, user.userID);
			if (schoolID) {
				const allSchoolClassIDs = _.get(schoolState, [
					"accounts",
					"schools",
					schoolID,
					"classIDs",
				]);
				classes = _.filter(classes, c => _.includes(allSchoolClassIDs, c.id));
			}

			if (grade != null) {
				classes = _.filter(classes, c => c.gradeID === grade);
			}
			if (displayedGrade != null) {
				classes = _.filter(classes, c => c.displayedGrade === displayedGrade);
			}
			if (year) {
				classes = _.filter(classes, c => c.year === year);
			}

			tableData = this.getClassData(classes);
		} else if (type === "schools") {
			columnNames = ["name", "classes", "teachers", "students", "status"];
			headerVals = [
				"School",
				"Active Classes",
				"Active Teachers",
				"Active Students",
				"",
			];
			const schools = OpsSchool.getViewableSchools(schoolState, user.userID);
			tableData = this.getSchoolData(schools);
		}
		const sortableColumns = [
			"name",
			"classes",
			"teachers",
			"students",
			"grade",
			"level",
			"school",
			"class",
			"teacher",
		];

		if (_.isEmpty(tableData)) {
			const scope = schoolID || isSingleSchool ? "school" : "system";
			return (
				<div className={styles.emptyTable}>
					{CopyTable.getEmptyTableCopy(type, scope, grade || year)}
				</div>
			);
		}

		return (
			<div className={styles.table}>
				<SortableTable
					columnNames={columnNames}
					sortableColumns={sortableColumns}
					headers={_.zipObject(columnNames, headerVals)}
					initiallySortedBy="name"
					data={tableData}
					sortFunctions={this.sortFunctions}
					widthClasses={this.widthClasses}
					headerClasses={this.headerClasses}
					evenRowDark={true}
					canScroll={true}
					grayOutInactive={true}
				/>
			</div>
		);
	},

	render: function() {
		const {tab, pageData, schoolState, showModal, user} = this.props;
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
		let content;
		if (tab === "staff") {
			content = (
				<StaffTables
					user={user}
					pageData={pageData}
					schoolState={schoolState}
					showModal={showModal}
				/>
			);
		} else {
			content = this.renderTable(tab, pageData);
		}

		let isActive = _.get(schoolState, "accounts.purchase.active");
		let bestRole = OpsSchool.isSchoolAdmin(schoolState, user.userID)
			? "schoolAdmin"
			: null;
		if (pageData.schoolID) {
			isActive = OpsSchool.isSchoolActive(schoolState, pageData.schoolID);
			bestRole = OpsSchool.getBestRoleForSchool(
				schoolState,
				user.userID,
				pageData.schoolID
			);
		} else if (pageData.classID) {
			bestRole = OpsSchool.getBestRoleForClass(
				schoolState,
				user.userID,
				pageData.classID
			);
		}
		const isPurchaseAdmin = OpsSchool.isPurchaseAdmin(schoolState, user.userID);

		let addButton;
		if (!isActive) {
			// TODO: also check for at least school admin perms for scope
			// No add button needed
		} else if (tab === "schools") {
			if (isPurchaseAdmin) {
				addButton = (
					<div
						className={styles.add}
						onClick={() => showModal("addInfo", "school")}
					>
						Add School
					</div>
				);
			}
		} else if (tab === "classes") {
			if ((bestRole === "schoolAdmin" || isPurchaseAdmin) && !isAcademy) {
				addButton = (
					<div
						className={styles.add}
						onClick={() =>
							OpsSchool.getViewableSchools(schoolState, user.userID).length
								? showModal("addInfo", "class")
								: showModal("warn", "noSchool")
						}
					>
						Add Class
					</div>
				);
			}
		} else if (tab === "students") {
			let classes = OpsSchool.getEditableClasses(schoolState, user.userID);
			classes = _.filter(classes, c => c.active);
			if ((bestRole === "schoolAdmin" || isPurchaseAdmin) && !isAcademy) {
				if (!_.isEmpty(classes)) {
					addButton = (
						<div
							className={styles.add}
							onClick={() => showModal("addInfo", "student")}
						>
							Add New Student
						</div>
					);
				} else {
					addButton = (
						<div className={styles.emptyTable}>
							Please first add a class before adding students.
						</div>
					);
				}
			}
		}

		return (
			<div className={styles.main}>
				{content}
				{addButton}
			</div>
		);
	},
});
